export const reportTypeEnum = Object.freeze({
  PIE: "Pie Chart",
  DOUGHNUT: "Doughnut Chart",
  GROUPCOL: "Group Column Chart",
  BAR: "Bar Chart",
  COLUMN: "Column Chart",
  STUCKED_COLUMN: "Stuck Column Chart",
  GROUPBAR: "Group Bar Chart",
  GEO_MUNICIPALS: "Municipality Geography Chart",
  GEO_PROVINCES: "Provincial Geography Chart",
  DUALAXES: "Dual Axis Chart",
  FUNNEL: "Funnel Chart",
  STACKED_AREA: " stacked area chart",
  HEATMAP: "Heat Map Chart",
});

export const fieldValidity = Object.freeze({
  "SUCCESS": "success",
  "ERROR": "error",
  "WARNING": "warning",
})

export const docsEnum = Object.freeze({
  "CURRICULUM_VITAE": "Curriculum Vitae (CV)",
  "QUALIFICATION": "Copy of Highest Qualification",
  "CERTIFIED_ID": "Certified ID Copy",
  "GRADE_12_CERT": "Grade 12 Certified Copy",
  "MOTIVATION": "Motivation Letter",
});

export const genEnum = Object.freeze({
  "MALE": 45,
  "FEMALE": 46,
  "OTHER": 47
});

export const defaultSettingEnum = Object.freeze({
  "COUNTRY_CODE": "+27",
  "COUNTRY": "South Africa",
})

export const progressIndicatorEnum = Object.freeze({
  "NOT_STARTED": "wait",
  "IN_PROGRESS": "process",
  "COMPLETED": "finish",
})

export const citizenScienceStatusEnum = Object.freeze({
  "PROJECT_LEAD": "0",
  "PROJECT_DETAILS": "1",
  "ORGANIZATIONS": "2",
  "PARTICIPANTS": "3",
  "BENEFICIARY": "4",
})

export const citizenScienceStatusContribEnum = Object.freeze({
  "HOST_ORG": "Host Organization",
  "FUNDING": "Funding",
})


export const contribEnum = Object.freeze({
  "FUNDING": "Funding",
  "EXHIBITOR": "Exhibitor",
  "VENUE": "Venue",
  "COMPLEMENTARY_ACTIVITY": "Complementary Activity",
  "OTHER": "Other",
})

export const localityEnum = Object.freeze({
  "LOCAL": "Local",   
  "FOREIGN": "Foreign"})

export const booleanEnum = Object.freeze({
  "YES": "Yes",   
  "NO": "No"})

export const paginationEnum = Object.freeze({
  "DEFAULT_PAGE_SIZE": 10,
  "DEFAULT_MAX_TOTAL": 100,
  "DEFAULT_FIRST_PAGE": 1,
  "DEFAULT_FIRST_RECORD": 0
})

export const csParticipRoleEnum = Object.freeze({
  "CONCEPTUALISATION": "pre",
  "DURING": "during",
  "POST": "post",
})